"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CategoryPageContainer = void 0;
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _components = require("../components");
var _constants = require("../constants");
var _logger2 = require("../logger");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component that wraps `CategoryPage` with relevant Providers (TestIdProvider, ThemeProvider, TranslationsProvider).
 */ const CategoryPageContainer = (param)=>{
    let { className, breadcrumbs, data, preview } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
        team: _constants.APP_TEAM_NAME,
        project: _constants.APP_NAME,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
            logger: _logger2.mainLogger,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
                areaName: "EditorialCategoryPageContainer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                    namespace: _constants.translationsNamespace,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.CategoryPage, {
                        className: className,
                        breadcrumbs: breadcrumbs,
                        data: data,
                        preview: preview
                    })
                })
            })
        })
    });
};
exports.CategoryPageContainer = CategoryPageContainer;
